define([
    './_site',
    './slider',
    'particles'
], function(
    Site,
    Slider,
    Particles
) {
    var _self;
    // console.log('banner');

    // obj
    _self = {
        initParticles: function() {
            var el = 'particles-js';

            if (!$('#' + el).length) {
                return;
            }

            particlesJS(el, {
                "particles": {
                    "number": {
                        "value": 200,
                        "density": {
                            "enable": true,
                            "value_area": 800
                        }
                    },
                    "color": {
                        "value": "#b89b61"
                    },
                    "shape": {
                        "type": "circle",
                        "stroke": {
                            "width": 0,
                            "color": "#000000"
                        },
                        "polygon": {
                            "nb_sides": 5
                        },
                        "image": {
                            "src": "img/temp/test.png",
                            "width": 100,
                            "height": 100
                        }
                    },
                    "opacity": {
                        "value": 0.2,
                        "random": true,
                        "anim": {
                            "enable": true,
                            "speed": 0.2,
                            "opacity_min": 0.01,
                            "sync": false
                        }
                    },
                    "size": {
                        "value": 16,
                        "random": true,
                        "anim": {
                            "enable": true,
                            "speed": 1,
                            "size_min": 0.1,
                            "sync": false
                        }
                    },
                    "line_linked": {
                        "enable": false,
                        "distance": 150,
                        "color": "#ffffff",
                        "opacity": 0.4,
                        "width": 1
                    },
                    "move": {
                        "enable": true,
                        "speed": 0.1,
                        "direction": "top",
                        "random": false,
                        "straight": false,
                        "out_mode": "out",
                        "bounce": false,
                        "attract": {
                            "enable": false,
                            "rotateX": 600,
                            "rotateY": 1200
                        }
                    }
                },
                "interactivity": {
                    "detect_on": "canvas",
                    "events": {
                        "onhover": {
                            "enable": false,
                            "mode": "repulse"
                        },
                        "onclick": {
                            "enable": false,
                            "mode": "push"
                        },
                        "resize": true
                    },
                    "modes": {
                        "grab": {
                            "distance": 400,
                            "line_linked": {
                                "opacity": 1
                            }
                        },
                        "bubble": {
                            "distance": 400,
                            "size": 40,
                            "duration": 2,
                            "opacity": 8,
                            "speed": 3
                        },
                        "repulse": {
                            "distance": 200,
                            "duration": 0.4
                        },
                        "push": {
                            "particles_nb": 4
                        },
                        "remove": {
                            "particles_nb": 2
                        }
                    }
                },
                "retina_detect": true
            });
        },
        triggerBannerNav: function($el) {
            var $slider = $el.closest('.slider'),
                $cycle = $slider.find('.slider__cycle'),
                $siblings = $el.siblings(),
                activeClass = 'banner-thumbs__item--active',
                index = $el.index();

            console.log(index);

            $siblings.removeClass(activeClass);
            $el.addClass(activeClass);

            $cycle.stop(true, true).slick('slickGoTo', index);
        }
    };


    // -------------------
    // BINDS
    // -------------------

    // main banner
    Slider.create($('.banner-slider'), {
        // fade: false,
        // draggable: false,
        dots: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        waitForAnimate: false,
        autoplay: true,
        autoplaySpeed: 5000,
        lazyLoad: 'ondemand',
        responsive: [
            // {
            //     breakpoint: Site.breakpoints.md,
            //     settings: {
            //         draggable: true
            //     }
            // },
            // {
            //     breakpoint: Site.breakpoints.sm,
            //     settings: {
            //         draggable: true,
            //         dots: true,
            //         fade: true
            //     }
            // },
            // {
            //     breakpoint: Site.breakpoints.xs,
            //     settings: {
            //         draggable: true,
            //         dots: true,
            //         fade: true
            //     }
            // }
        ]
    });

    // hover over thumbs
    $('.banner-thumbs__item').on('click', function() {
        _self.triggerBannerNav($(this));
    });

    // particles
    _self.initParticles();

    return _self;
});
